import React, { useState } from "react";
import { CalenderIcon, PlusIconCircle } from "../../../Icon";
import { Col, Label, Progress, Row } from "reactstrap";
import moment from "moment";

type AppProps = {
  startDate: any;
  endDate: any;
  dateRange: any;
  previousHours: any;
  handleProgressInputChange: (item: any, date: any) => void;
  dailyHours?: any;
  dailyTotal?: number
  update?: string | undefined;
  userId?: number | undefined;
  showSchedulingEstimateData: any;
};

const DailyEstimate = ({
  startDate,
  endDate,
  dateRange,
  handleProgressInputChange,
  previousHours,
  dailyHours,
  dailyTotal,
  update,
  userId,
  showSchedulingEstimateData
}: AppProps) => {
  const [progressCount, setProgressCount] = useState<any>({});
  let todaysDate = moment().format("YYYY-MM-DD");

  if (!dateRange.length) {
    return <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '55vh',
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#555'
    }}>Please select date range available</div>;
  }
  return (

    <div className="mt-4" style={{ width: "100%" }}>
      <div
        className="jobsType"
        style={{ overflowY: "scroll", maxHeight: "60vh" }}
      >
        <table className="table table-bordered thead-light">
          <thead
            className="text-start"
            style={{
              backgroundColor: "#f4f6f8",
              color: "#464f60",
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            <tr
              style={{
                color: "#464f60",
                backgroundColor: "#e8ecf0",
              }}
            >
              <div
                className=""
                style={{
                  display: "flex",
                  width: "100%",
                  padding: "10px",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "200px" }}> TOTAL</div>

                <div style={{ width: "300px", display: "flex", justifyContent: "center" }}>{dailyTotal?.toFixed(2)}</div>
                <div style={{ width: "400px" }}></div>
              </div>
            </tr>
            <tr
              style={{
                color: "#464f60",
                backgroundColor: "#f4f6f8",
              }}
            >
              <div
                className="sticky-table-header"
                style={{
                  display: "flex",
                  width: "100%",
                  padding: "10px",
                  justifyContent: "space-between",
                  zIndex: 0
                }}
              >
                <div className="" style={{ width: "200px" }}> DATE</div>

                <div style={{ width: "300px", display: "flex", justifyContent: "center" }}>Hours</div>
                <div style={{ width: "400px", display: "flex", justifyContent: "center" }}>{update ? "Employee scheduled hours" : "Your scheduled hours"}</div>
              </div>
            </tr>
          </thead>
          <tbody style={{ alignItems: "center" }} className="col-md-12">


            {dateRange.map((item: any, i: number) => {

              return (
                <tr key={i}>
                  <td>
                    <div style={{ alignItems: "center", display: "flex", justifyContent: "space-between" }}>
                      <div style={{ width: "200px" }}>
                        <span
                          style={{
                            background: "#bfcbe1",
                            padding: "10px 5px",
                            borderRadius: "5px",
                            alignItems: "center",
                            display: "flex",
                            width: "200px"
                          }}
                        >
                          <span style={{ marginRight: "15px" }}>
                            {moment(item?.date).format(" ddd,DD-MM-YYYY")}
                          </span>
                          <span style={{ marginRight: "10px" }}>
                            <CalenderIcon />
                          </span>
                        </span>
                      </div>
                      <div style={{ width: "300px", display: "flex", justifyContent: "center" }}>
                        <input
                          type="number"
                          value={
                            item?.hours
                          }
                          disabled={!!item?.date && moment(item?.date).format("YYYY-MM-DD") < todaysDate}
                          onChange={(e) => handleProgressInputChange(e.target.value, i)}
                          className="form-control"
                          style={{ width: "22%" }}
                          onWheel={(event) => event.currentTarget.blur()}
                        />
                      </div>
                      <div style={{ flexGrow: "1", maxWidth: "400px" }}>

                        <div className='d-flex'>
                          <Progress
                            striped
                            style={{ height: "15px", marginRight: "10px", width: "100%", backgroundColor: "#bfcbe1" }}
                            value={item?.progressCount}
                            max={12}
                            // color="success"
                            color={item?.progressCount >= 12 ? "warning" : "success"}

                          >
                          </Progress>
                          <span style={{ marginRight: "10px" }}>{item?.progressCount ? item?.progressCount : 0}/12</span>
                        </div>



                        <div style={{ color: "red", fontSize: "12px" }}>
                          {item?.errorMessage ?
                            item?.errorMessage
                            : null}
                        </div>


                      </div>



                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DailyEstimate;
